<template>
  <div>
    <v-textarea
      ref="textarea"
      v-model="computedValue"
      :hide-details="hideDetails && (!rules || !rules.length)"
      :label="label"
      :rows="rows"
      :rules="rules"
      :hint="hint"
      :counter="counter"
      clear-icon="mdi-close-circle-outline"
      prepend-inner-icon="mdi-text-box-edit"
      clearable
      dense
      outlined
      class="contentinfo"
    >
      <!-- دکمه‌های ایموجی، هوش مصنوعی طلا و چک‌باکس جداکننده -->
      <template v-if="$vuetify.breakpoint.smAndUp" v-slot:append>
        <div class="d-flex flex-column fill-height justify-space-between align-center" style="gap: 4px;">
          <!-- ایموجی -->
          <v-btn
            class="px-0"
            min-width="32"
            small
            style="font-size: 1.3em"
            text
            title="انتخاب ایموجی"
            @click="emojiModel = true"
          >
            <div>🙂</div>
          </v-btn>

          <!-- دکمه هوش مصنوعی برای تولید توضیحات طلا -->
          <v-btn
            class="px-0"
            :loading="loading_Ai"
            min-width="32"
            color="amber darken-2"
            small
            text
            title="تولید توضیحات طلا با هوش مصنوعی"
            @click="generateTextForGold(prompt)"
          >
            <v-icon>mdi-creation-outline</v-icon>
          </v-btn>

          <!-- اسلات برای دریافت چک‌باکس خط جداکننده (line) -->
          <slot name="append-line"></slot>
        </div>
      </template>
    </v-textarea>

    <!-- دکمه‌ها برای سایز موبایل -->
    <div v-if="$vuetify.breakpoint.xs" class="d-flex align-center mt-1">
      <v-btn
        class="px-2"
        style="font-size: 1.3em"
        text
        @click="emojiModel = true"
      >
        <div>✨</div>
      </v-btn>
      <v-btn
        icon
        color="amber darken-2"
        :loading="loading_Ai"
        @click="generateTextForGold(prompt)"
      >
        <v-icon>mdi-creation-outline</v-icon>
      </v-btn>
    </div>

    <!-- دیالوگ خرید پکیج در صورت اتمام اعتبار -->
    <TogetherAiUpgradeNew
      v-model="showUpgrade"
      :current-package.sync="currentPackage"
      class="contentinfo"
    />

    <!-- سلکتور ایموجی -->
    <custom-popup
      v-model="emojiModel"
      :cons="cons"
      hide-confirm
      max-width="500"
    >
      <emoji-selector :inputBox="$refs.textarea" />
    </custom-popup>
  </div>
</template>

<script>
import EmojiSelector from "./emoji";
import TogetherAiUpgradeNew from "@/view/components/adapters/AIGeneration/togetherAiUpgradeNew.vue";

export default {
  name: "suggestTextGold",

  components: {
    EmojiSelector,
    TogetherAiUpgradeNew,
  },

  props: {
    rules: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "درباره طلا",
    },
    prompt: {
      type: String,
      default: "",
    },
    hint: {
      type: String,
      default: "لطفا توضیحات محصول خود را وارد کنید.",
    },
    counter: {
      type: [String, Number],
      default: 2000,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: [String, Number],
      default: 5,
    },
  },

  data() {
    return {
      showUpgrade: false,
      currentPackage: {},
      loading_Ai: false,
      emojiModel: false,
    };
  },

  computed: {
    cons() {
      return {
        title: this.$t ? this.$t("suggestinput.title") : "انتخاب ایموجی",
      };
    },
    computedCurrentPackage() {
      const packages = this.currentPackage;
      return packages.remaining instanceof Array
        ? packages.remaining.reduce((obj, curr) => {
            obj.free = false;
            if (!obj.hasOwnProperty("count"))
              obj.count = Number(curr.remaining);
            else obj.count += Number(curr.remaining);
            return obj;
          }, {})
        : {
            free: packages.package_id === null,
            count: packages.remaining,
          };
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    generateTextForGold(prompt) {
      this.loading_Ai = true;
      const needPack = !this.computedCurrentPackage.count;
      const goldTitle = prompt && prompt.trim().length > 0 ? prompt : "محصول طلا و جواهر";

      const textMessage = {
        fa: `شما یک کارشناس و نویسنده حرفه‌ای در زمینه طلا، جواهرات و مسکوکات طلا هستید. یک متن معرفی و توضیحات محصول کامل، جذاب و متناسب (حدود ۱۵۰ تا ۲۵۰ کلمه) برای محصول «${goldTitle}» بنویسید.

راهنمای لحن و محتوا بر اساس نوع محصول:
۱. اگر محصول «سکه بهار آزادی / امامی / گرمی» است: روی اصالت، عیار استاندارد قانونی، نقدشوندگی بسیار بالا، حفظ ارزش دارایی در برابر تورم و بهترین گزینه برای پس‌انداز و سرمایه‌گذاری تمرکز کنید.
۲. اگر «سکه پارسیان / کادویی» است: روی عیار استاندارد، بسته‌بندی امن و معتبر، هدیه‌ای ارزشمند، ماندگار و اقتصادی برای مناسبت‌ها و یادبودها و نقدشوندگی آسان تأکید کنید.
۳. اگر «مصنوعات طلا و جواهر» است: روی ظرافت در ساخت، درخشش ماندگار، پرستیژ، زیبایی در استایل و ارزش توأم هدیه و پس‌انداز تمرکز کنید.

لحن متن کاملاً رسمی، مطمئن و در شأن بازار طلا باشد. فقط متن نهایی را بدون تیتر، عنوان، سلام یا پیام اضافه خروجی دهید.`,

        en: ` an expert copywriter in the luxury jewelry, bullion, and gold coins market. Write a captivating, high-end, and accurate product description (around 150-250 words) for: "${goldTitle}".

Content guidelines based on product type:
1. If bullion or official gold coins: Emphasize certified purity, high liquidity, safe-haven wealth preservation against inflation, and solid investment value.
2. If gift/fractional gold bars or medallion cards (like Parsian/commemorative plaques): Focus on certified assay, tamper-evident security packaging, and being an elegant, prestigious yet accessible gift for special occasions and savings.
3. If crafted jewelry: Highlight exquisite craftsmanship, timeless brilliance, personal elegance, authenticity, and enduring luxury appeal.

Maintain an upscale, trustworthy tone. Output ONLY the final description text in English, with no headings, introductory filler, or concluding remarks.`,

        ar: `أنت كاتب محتوى متخصص وخبير في قطاع الذهب والمجوهرات والمسكوكات الذهبية. اكتب وصفاً تسويقياً راقياً ومقنعاً (من 150 إلى 250 كلمة) لمنتج: "${goldTitle}".

إرشادات الصياغة حسب نوع المنتج:
1. إذا كان المنتج سبائك أو ليرات/عملات ذهبية رسمية: ركّز على العيار القانوني المعتمد، والسيولة العالية، وحفظ القيمة وملاذاً آمناً ضد التضخم والاستثمار المضمون.
2. إذا كان المنتج سبائك وبطاقات إهدائية/مسكوكات هدايا: أكّد على التغليف الأمني المعتمد، وكونه خياراً فاخراً واقتصادياً للإهداء في المناسبات وحفظ المدخرات.
3. إذا كان المنتج مصوغات ومجوهرات: سلّط الضوء على دقة الصياغة، والبريق الخالد، والأناقة العالية، وقيمته كقطعة زينة واستثمار معاً.

اجعل النبرة رسمية وموثوقة وفاخرة. أخرج النص النهائي فقط باللغة العربية دون أي عناوين أو مقدمات أو خواتيم إضافية.`
      }[this.$i18n ? this.$i18n.locale : "fa"] || "";

      this.$api
        .post(this.$aiApi + "/chat/tmp/chat", {
          model: "gpt-4o-mini",
          message: textMessage,
        })
        .then(({ data }) => {
          this.computedValue = data.choices[0].message.content;
          this.currentPackage = data.package;

          if (needPack && !data.package.remaining) {
            this.showUpgrade = true;
            this.$modal.error(
              this.$t ? this.$t("suggestinput.error") : "خطا",
              this.$t ? this.$t("suggestinput.errorMessage") : "اعتبار شما به پایان رسیده است."
            );
          }
        })
        .catch((err) => {
          const message = this.$t ? this.$t("suggestinput.errorMessage_400") : "خطا در برقراری ارتباط";
          if (err.response && err.response.status === 403) {
            if (this.$toast) this.$toast.error(this.$t("suggestinput.errorMessage_403"));
            this.showUpgrade = true;
          } else {
            if (this.$modal) this.$modal.error(this.$t("suggestinput.error"), message);
          }
        })
        .finally(() => {
          this.loading_Ai = false;
        });
    },
  },
};
</script>

<style scoped>
.v-input >>> .v-input__append-inner {
  margin: 0;
  align-self: stretch;
}
</style>
